import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import vehiclesData from "../../data/vehiclesData";
import VehicleServicesCard from "../../components/cards/VehicleServicesCard/VehicleServicesCard";
import "./ServicesPage.css";
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";
import { useTranslation } from "react-i18next";

export default function ServicesPage() {
  const { t } = useTranslation();

  const vehiclesWithServices = vehiclesData.filter(
    (v) => v.servicePackages && v.servicePackages.variants?.length > 0
  );

  return (
    <div className="Page">
      <div className="servicesPageBanner text-center">
        <div className="page-banner-content">
          <h3>{t("servicesPage.bannerSubtitle")}</h3>
          <h1>{t("servicesPage.bannerTitle")}</h1>
        </div>
      </div>

      <Container fluid>
        <div className="section-spacing">
          <p className="brand-section-desc text-center mb-0">
            {t("servicesPage.tagline")}
          </p>
        </div>

        <Row className="gy-4">
          {vehiclesWithServices.map((vehicle) => (
            <Col key={vehicle.id} xs={12} md={6} lg={4}>
              <VehicleServicesCard vehicle={vehicle} />
            </Col>
          ))}
        </Row>
      </Container>

      <div className="section-spacing-top">
        <AftersalesSupportSection />
      </div>
    </div>
  );
}